<template>
  <div class="empty-state">
    <i :class="`pi ${emptyStateConfig.icon}`" />
    <h3>{{ emptyStateConfig.title }}</h3>
    <p>{{ emptyStateConfig.description }}</p>
  </div>
</template>

<script setup lang="ts">
// Types
interface EmptyStateConfig {
  title: string;
  description: string;
  icon: string;
}

interface Props {
  emptyStateConfig: EmptyStateConfig;
}

// Props
defineProps<Props>();
</script>

<style lang="scss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  text-align: center;

  i {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  h3 {
    margin: 1rem 0;
    font-weight: 500;
  }

  p {
    margin-bottom: 1rem;
    font-weight: 400;
  }
}
</style>
